import { retrieveAvailableFilters } from 'redux/availableFilters/selectors'

export const INIT_AVAILABLE_FILTERS = 'INIT_AVAILABLE_FILTERS'
export function initAvailableFilters(type) {
    return function initAvailableFilters(dispatch, getState) {
        dispatch({
            type: INIT_AVAILABLE_FILTERS,
            filters: retrieveAvailableFilters(getState(), type)
        })
    }
}
